document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.collection-submenu__wrapper').forEach(wrapper => {
    const scroller = wrapper.querySelector('.collection-submenu');
    if (!scroller) return;

    const prev = wrapper.querySelector('.collection-submenu__arrow--prev');
    const next = wrapper.querySelector('.collection-submenu__arrow--next');

    const step = () => {
      const card = scroller.querySelector('.collection-submenu__card');
      const gap  = parseFloat(getComputedStyle(scroller).gap || 0);
      return (card ? card.offsetWidth : 200) + gap;
    };

    prev.addEventListener('click', () => {
      scroller.scrollBy({ left: -Math.min(step(), scroller.scrollLeft), behavior: 'smooth' });
    });
    next.addEventListener('click', () => {
      const maxRight = scroller.scrollWidth - scroller.clientWidth - scroller.scrollLeft;
      scroller.scrollBy({ left: Math.min(step(), maxRight), behavior: 'smooth' });
    });

    const updateDisabled = () => {
      const max = scroller.scrollWidth - scroller.clientWidth - 1;
      prev.classList.toggle('is-disabled', scroller.scrollLeft <= 0);
      next.classList.toggle('is-disabled', scroller.scrollLeft >= max);
    };

    const positionArrows = () => {
      const imgBox = scroller.querySelector('.collection-submenu__image');
      if (!imgBox) return;
      const wrapRect = wrapper.getBoundingClientRect();
      const imgRect  = imgBox.getBoundingClientRect();
      const centerY  = imgRect.top - wrapRect.top + imgRect.height / 2;
      prev.style.top = next.style.top = `${centerY}px`;
    };

    scroller.addEventListener('scroll', updateDisabled, { passive: true });
    window.addEventListener('resize', () => { positionArrows(); updateDisabled(); });
    window.addEventListener('load', () => { positionArrows(); updateDisabled(); });

    positionArrows();
    updateDisabled();
  });
});